import React from 'react';

import classes from './GoogleLogo.module.css';

const googleLogo = () => {
    return (
        <div>
            <img className={classes.googleLogo} src="/assets/images/google-logo.png" alt="Google Logo" />
        </div>
    );
};

export default googleLogo;
